import React from 'react';
import { Controller, SubmitHandler, UseFormReturn } from 'react-hook-form';
import { UserDataFormType } from 'entities/users/types';
import { Box, Button, Checkbox, MenuItem, TextField } from '@mui/material';
import { useGetUserRolesQuery } from 'features/getUserRoles/getUserRolesApi';
import { useGetSourcesQuery } from 'features/getSources/api/getSourcesApi';
import { CircularLoader } from 'shared/ui/CircularLoader/CircularLoader';

type UserDataCardPropsType = {
  form: UseFormReturn<UserDataFormType>;
  onSubmit: (data: UserDataFormType) => SubmitHandler<UserDataFormType>;
};
export const UserDataCard = ({ form, onSubmit }: UserDataCardPropsType) => {
  const { data: user_roles, isSuccess: isUserRolesSuccess } = useGetUserRolesQuery('');
  const { data: sources, isSuccess: isSourcesSuccess } = useGetSourcesQuery('');

  const { control, handleSubmit } = form;

  if (!isUserRolesSuccess || !isSourcesSuccess) {
    return <CircularLoader />;
  }

  return (
    <>
      <Controller
        name="phone"
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            type="text"
            label="Телефон"
            fullWidth
            sx={{
              marginTop: '30px',
              marginBottom: '24px',
            }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            {...field}
          />
        )}
      />
      <Controller
        name="user_role_ids"
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            select
            type="text"
            label="Роль"
            fullWidth
            sx={{
              marginBottom: '24px',
            }}
            SelectProps={{
              multiple: true,
            }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            {...field}
          >
            {user_roles?.map((item: { name: string; id: number }) => (
              <MenuItem
                value={item.id}
                key={item.id}
              >
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
      <Controller
        name="source_id"
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            select
            type="text"
            label="Источник"
            fullWidth
            sx={{
              marginBottom: '24px',
            }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            {...field}
          >
            {sources?.map((item: { name: string; id: number }) => (
              <MenuItem
                value={item.id}
                key={item.id}
              >
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '24px',
        }}
      >
        <Controller
          control={control}
          name="is_b2b"
          render={({ field: { value, ...restField } }) => (
            <>
              <Checkbox
                checked={value}
                {...restField}
              />{' '}
              B2B
            </>
          )}
        />
        <Controller
          control={control}
          name="is_b2c"
          render={({ field: { value, ...restField } }) => (
            <>
              <Checkbox
                checked={value}
                {...restField}
              />{' '}
              B2C
            </>
          )}
        />
        <Controller
          control={control}
          name="is_b2cr"
          render={({ field: { value, ...restField } }) => (
            <>
              <Checkbox
                checked={value}
                {...restField}
              />{' '}
              B2CR
            </>
          )}
        />
      </Box>

      <Button
        type="submit"
        variant="contained"
        onClick={handleSubmit(onSubmit)}
      >
        Сохранить
      </Button>
    </>
  );
};
